import React from "react";
import { FieldAttributes, useField, useFormikContext } from "formik";
import classNames from "classnames";

function Input<T>(props: FieldAttributes<T>) {
  const [field, meta] = useField(props);
  const formik = useFormikContext();
  const showError = formik && formik.submitCount > 0 && meta.error;
  // const showError = meta.touched && meta.error;
  const { className: existingClasses, ...rest } = props;
  const className = classNames(existingClasses, { ErrorInput: showError });

  return <input {...(field as any)} {...rest} className={className} />;
}

export { Input };
